class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* Upsell Add-to-Cart — adds variant, refreshes sidebar via AJAX */
(function initUpsellATC() {
  function updateUpsellPanelVisibility() {
    var panel = document.getElementById('cart-sidebar-upsells');
    if (!panel) return;
    var sidebar = document.getElementById('halo-cart-sidebar');

    var visibleUpsellCount = panel.querySelectorAll('.upsell-item').length;
    var isEmpty = visibleUpsellCount === 0;

    panel.classList.toggle('is-empty', isEmpty);
    panel.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
    panel.setAttribute('data-upsell-count', String(visibleUpsellCount));

    if (sidebar) {
      sidebar.classList.toggle('has-upsells', !isEmpty);
    }
  }

  function bindUpsellSliderArrow() {
    var panel = document.getElementById('cart-sidebar-upsells');
    if (!panel) return;

    var list = panel.querySelector('.cart-sidebar-upsells__list');
    var nextButton = panel.querySelector('[data-upsell-next]');
    if (!list || !nextButton || nextButton.dataset.upsellSliderBound) return;

    nextButton.dataset.upsellSliderBound = 'true';
    nextButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (!window.matchMedia('(max-width: 1024px)').matches) return;

      var firstCard = list.querySelector('.upsell-item');
      var step = firstCard ? Math.round(firstCard.getBoundingClientRect().width + 10) : Math.round(list.clientWidth * 0.9);
      list.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  function setUpsellButtonState(button, state) {
    if (!button) return;
    if (!button.dataset.defaultHtml) button.dataset.defaultHtml = button.innerHTML;
    if (!button.dataset.defaultAriaLabel) button.dataset.defaultAriaLabel = button.getAttribute('aria-label') || 'Add to cart';

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.classList.remove('is-added');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span class="upsell-item__atc-text">...</span>';
      return;
    }

    if (state === 'added') {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.disabled = true;
      button.setAttribute('aria-busy', 'false');
      button.setAttribute('aria-label', 'Added');
      button.innerHTML = '<span class="upsell-item__atc-check">✓</span>';
      return;
    }

    button.classList.remove('is-loading', 'is-added');
    button.disabled = false;
    button.setAttribute('aria-busy', 'false');
    button.setAttribute('aria-label', button.dataset.defaultAriaLabel);
    button.innerHTML = button.dataset.defaultHtml;
  }

  function bindUpsellButtons() {
    document.querySelectorAll('[data-upsell-atc]').forEach(function(btn) {
      if (btn.dataset.upsellBound) return;
      btn.dataset.upsellBound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var button = e.currentTarget;
        var variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        setUpsellButtonState(button, 'loading');

        fetch(window.routes.root + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function(res) {
          return res.text().then(function(text) {
            var parsedState = {};

            try {
              parsedState = text ? JSON.parse(text) : {};
            } catch (parseError) {
              var parseFailure = new Error('Upsell add failed');
              parseFailure.cartAddData = {
                description: (window.cartStrings && window.cartStrings.addProductOutQuantity2) || 'This item is not available in the requested quantity.'
              };
              throw parseFailure;
            }

            if (!res.ok || parsedState.status >= 400 || parsedState.description) {
              var error = new Error('Upsell add failed');
              error.cartAddData = parsedState;
              throw error;
            }

            return parsedState;
          });
        })
        .then(function() {
          setUpsellButtonState(button, 'added');
          var upsellCard = button.closest('.upsell-item');
          if (upsellCard) {
            upsellCard.classList.add('is-added');
            setTimeout(function() {
              if (upsellCard && upsellCard.parentNode) {
                upsellCard.remove();
                updateUpsellPanelVisibility();
              }
            }, 320);
          }

          if (typeof Shopify !== 'undefined' && Shopify.getCart) {
            Shopify.getCart(function(cart) {
              if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
                window.sharedFunctions.updateSidebarCart(cart);
              } else if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
                halo.updateSidebarCart(cart);
              }
            });
          }
        })
        .catch(function(error) {
          if (window.BGCartAvailability) {
            window.BGCartAvailability.showWarning(error);
          }
          setUpsellButtonState(button, 'idle');
        });
      });
    });
  }

  /* Bind on initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bindUpsellButtons();
      bindUpsellSliderArrow();
      updateUpsellPanelVisibility();
    });
  } else {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
  }

  /* Re-bind after AJAX cart updates (sidebar HTML gets replaced) */
  document.addEventListener('cart-update', function() {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
    initUpsellLoadMore();
  });
  document.addEventListener('theme.cart.drawer.loaded', function() {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
    initUpsellLoadMore();
  });

  /* Upsell Load More — fetches next page of collection products via AJAX */
  var UPSELL_SKIP_HANDLES = ['teca-lifting-moisture-cream', 'free-gift-teca-travel-kit', 'free-holika-holika-pure-essence-mask-sheet-pearl'];
  var UPSELL_SKIP_PRODUCT_IDS = [11840555385100];
  var UPSELL_SKIP_VARIANT_IDS = [54782246486284];
  var freeGiftConfig = window.freeGiftConfig || {};
  if (freeGiftConfig.maskHandle && UPSELL_SKIP_HANDLES.indexOf(freeGiftConfig.maskHandle) === -1) {
    UPSELL_SKIP_HANDLES.push(freeGiftConfig.maskHandle);
  }
  if (Number(freeGiftConfig.maskProductId) > 0 && UPSELL_SKIP_PRODUCT_IDS.indexOf(Number(freeGiftConfig.maskProductId)) === -1) {
    UPSELL_SKIP_PRODUCT_IDS.push(Number(freeGiftConfig.maskProductId));
  }
  if (Number(freeGiftConfig.maskVariantId) > 0 && UPSELL_SKIP_VARIANT_IDS.indexOf(Number(freeGiftConfig.maskVariantId)) === -1) {
    UPSELL_SKIP_VARIANT_IDS.push(Number(freeGiftConfig.maskVariantId));
  }
  var UPSELL_COLLECTION_HANDLE = 'upsells-cart';
  var UPSELL_ATC_SVG = '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M409.6 1024c-56.464 0-102.4-45.936-102.4-102.4s45.936-102.4 102.4-102.4S512 865.136 512 921.6 466.064 1024 409.6 1024zm0-153.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z"/><path d="M768 1024c-56.464 0-102.4-45.936-102.4-102.4S711.536 819.2 768 819.2s102.4 45.936 102.4 102.4S824.464 1024 768 1024zm0-153.6c-28.232 0-51.2 22.968-51.2 51.2s22.968 51.2 51.2 51.2 51.2-22.968 51.2-51.2-22.968-51.2-51.2-51.2z"/><path d="M898.021 228.688C885.162 213.507 865.763 204.8 844.8 204.8H217.954l-5.085-30.506C206.149 133.979 168.871 102.4 128 102.4H76.8c-14.138 0-25.6 11.462-25.6 25.6s11.462 25.6 25.6 25.6H128c15.722 0 31.781 13.603 34.366 29.112l85.566 513.395C254.65 736.421 291.929 768 332.799 768h512c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-512c-15.722 0-31.781-13.603-34.366-29.11l-12.63-75.784 510.206-44.366c39.69-3.451 75.907-36.938 82.458-76.234l34.366-206.194c3.448-20.677-1.952-41.243-14.813-56.424zm-35.69 48.006l-34.366 206.194c-2.699 16.186-20.043 32.221-36.39 33.645l-514.214 44.714-50.874-305.246h618.314c5.968 0 10.995 2.054 14.155 5.782 3.157 3.73 4.357 9.024 3.376 14.912z"/></svg>';

  function upsellFormatMoney(priceMajor) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(parseFloat(priceMajor) || 0);
    } catch (e) {
      return currency + ' ' + (parseFloat(priceMajor) || 0).toFixed(2);
    }
  }

  function buildUpsellCard(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return null;
    var priceMajor = parseFloat(variant.price || '0');
    var compareMajor = parseFloat(variant.compare_at_price || '0');
    var available = variant.available !== false;
    var image = product.images && product.images[0];

    var discountBadge = '';
    var compareHtml = '';
    if (compareMajor > priceMajor) {
      var pct = Math.round((compareMajor - priceMajor) / compareMajor * 100);
      discountBadge = '<span class="upsell-item__badge">-' + pct + '%</span>';
      compareHtml = '<s class="upsell-item__compare-price">' + upsellFormatMoney(compareMajor) + '</s>';
    }

    var imgHtml = image
      ? '<img src="' + image.src + '" alt="' + product.title.replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">'
      : '';

    var div = document.createElement('div');
    div.className = 'upsell-item';
    div.setAttribute('data-upsell-product-id', String(product.id));
    div.innerHTML =
      '<a href="/products/' + product.handle + '" class="upsell-item__image">' +
        imgHtml + discountBadge +
      '</a>' +
      '<div class="upsell-item__info">' +
        '<a href="/products/' + product.handle + '" class="upsell-item__name">' + product.title + '</a>' +
        '<div class="upsell-item__price">' + compareHtml +
          '<span class="upsell-item__current-price">' + upsellFormatMoney(priceMajor) + '</span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="upsell-item__atc button" data-upsell-atc data-variant-id="' + variant.id + '"' +
        (available ? '' : ' disabled') + ' aria-label="Add to cart">' +
        UPSELL_ATC_SVG +
      '</button>';
    return div;
  }

  function initUpsellLoadMore() {
    var btn = document.querySelector('[data-upsell-load-more]');
    if (!btn || btn.dataset.upsellLoadMoreBound) return;
    btn.dataset.upsellLoadMoreBound = 'true';

    btn.addEventListener('click', function() {
      var page = parseInt(btn.getAttribute('data-page') || '2', 10);
      var originalText = btn.textContent.trim();
      btn.classList.add('is-loading');
      btn.textContent = '...';

      var existingIds = Array.from(document.querySelectorAll('.upsell-item[data-upsell-product-id]'))
        .map(function(el) { return parseInt(el.getAttribute('data-upsell-product-id'), 10); });

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartProductIds = cart.items.map(function(item) { return item.product_id; });
          return fetch('/collections/' + UPSELL_COLLECTION_HANDLE + '/products.json?limit=20&page=' + page)
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = data.products || [];
              var list = document.querySelector('.cart-sidebar-upsells__list');
              if (!list) return;

              products.forEach(function(product) {
                if (UPSELL_SKIP_HANDLES.indexOf(product.handle) !== -1) return;
                if (UPSELL_SKIP_PRODUCT_IDS.indexOf(Number(product.id)) !== -1) return;
                if ((product.variants || []).some(function(variant) {
                  return UPSELL_SKIP_VARIANT_IDS.indexOf(Number(variant.id)) !== -1;
                })) return;
                if (existingIds.indexOf(product.id) !== -1) return;
                if (cartProductIds.indexOf(product.id) !== -1) return;
                var card = buildUpsellCard(product);
                if (card) list.appendChild(card);
              });

              bindUpsellButtons();
              updateUpsellPanelVisibility();

              if (products.length < 20) {
                btn.remove();
              } else {
                btn.setAttribute('data-page', String(page + 1));
                btn.classList.remove('is-loading');
                btn.textContent = originalText;
              }
            });
        })
        .catch(function() {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellLoadMore);
  } else {
    initUpsellLoadMore();
  }
})();
